import React, { useState, useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { useEntidadeContext } from '../../EntidadeContext';
import { useAuthContext } from '../../context/AuthContext';

const ICONS = {
  contract: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  sign:     'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
  eraser:   'M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2v-3.586a2 2 0 00-.586-1.414L14 5.586a2 2 0 00-1.414-.586H5a2 2 0 00-2 2v3.586A2 2 0 003 12z',
  save:     'M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4',
  check:    'M5 13l4 4L19 7',
  copy:     'M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z',
  tag:      'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a2 2 0 012-2z',
  user:     'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
};

const SvgIcon = ({ d, size = 14, color = 'currentColor', stroke = 2 }) => (
  <svg width={size} height={size} fill="none" stroke={color} viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={stroke} d={d} />
  </svg>
);

const inputBase = {
  width: '100%', padding: '9px 12px', borderRadius: '8px',
  border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
  fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff',
  boxSizing: 'border-box', transition: 'border-color .15s, box-shadow .15s',
};
const fh = {
  onFocus: e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,.1)'; },
  onBlur:  e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; },
};

const Btn = ({ children, onClick, disabled, loading, variant = 'primary', small }) => {
  const variants = {
    primary:   { bg: 'linear-gradient(135deg,#1e3a5f,#2563eb)', color: '#fff' },
    success:   { bg: 'linear-gradient(135deg,#14532d,#16a34a)', color: '#fff' },
    secondary: { bg: '#fff', color: '#374151', border: '1px solid #e5e7eb' },
    warning:   { bg: 'linear-gradient(135deg,#78350f,#d97706)', color: '#fff' },
    danger:    { bg: '#fff', color: '#dc2626', border: '1px solid #fecaca' },
  };
  const v = variants[variant];
  return (
    <button
      type="button" onClick={onClick} disabled={disabled || loading}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '6px',
        padding: small ? '6px 12px' : '9px 18px', borderRadius: '8px',
        border: v.border || 'none',
        background: (disabled || loading) ? '#f3f4f6' : v.bg,
        color: (disabled || loading) ? '#9ca3af' : v.color,
        fontSize: small ? '12px' : '13px', fontWeight: '600', fontFamily: 'inherit',
        cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
      }}
    >
      {loading && <Spinner as="span" animation="border" size="sm" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />}
      {children}
    </button>
  );
};

const VARIAVEIS = [
  { label: 'Nome do Paciente',      value: '{{paciente_nome}}' },
  { label: 'CPF do Paciente',       value: '{{paciente_cpf}}' },
  { label: 'Nacionalidade',         value: '{{paciente_nacionalidade}}' },
  { label: 'Estado Civil',          value: '{{paciente_estado_civil}}' },
  { label: 'Profissão',             value: '{{paciente_profissao}}' },
  { label: 'Endereço do Paciente',  value: '{{paciente_endereco}}' },
  { label: 'Telefone do Paciente',  value: '{{paciente_telefone}}' },
  { label: 'E-mail do Paciente',    value: '{{paciente_email}}' },
  { label: 'Nome da Clínica',       value: '{{clinica_nome}}' },
  { label: 'CNPJ da Clínica',       value: '{{clinica_cnpj}}' },
  { label: 'Serviços Contratados',  value: '{{servicos_contratados}}' },
  { label: 'Valor Total',           value: '{{valor_total}}' },
  { label: 'Data de Hoje',          value: '{{data_hoje}}' },
];

const CopiedToast = ({ show }) => (
  <div style={{
    position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999,
    display: 'flex', alignItems: 'center', gap: '8px',
    padding: '10px 18px', borderRadius: '10px',
    backgroundColor: '#1e3a5f', color: '#fff',
    fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
    boxShadow: '0 4px 20px rgba(0,0,0,.2)',
    transform: show ? 'translateY(0)' : 'translateY(80px)',
    opacity: show ? 1 : 0, transition: 'all .3s ease',
    pointerEvents: 'none',
  }}>
    <SvgIcon d={ICONS.check} size={14} color="#4ade80" stroke={2.5} />
    Variável copiada!
  </div>
);

const ContratoTemplateTab = () => {
  const { currentEntidade, setCurrentEntidade } = useEntidadeContext();
  const { loggedInUser } = useAuthContext();
  const sigPadRef = useRef(null);

  const [template, setTemplate]               = useState('');
  const [isSaving, setIsSaving]               = useState(false);
  const [isSavingSig, setIsSavingSig]         = useState(false);
  const [sigMsg, setSigMsg]                   = useState(null);
  const [copiedVar, setCopiedVar]             = useState(null);
  const [showCopiedToast, setShowCopiedToast] = useState(false);

  useEffect(() => {
    if (currentEntidade?.contrato_template) setTemplate(currentEntidade.contrato_template);
  }, [currentEntidade]);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await axios.put(`/api/entidades/${currentEntidade.id}`, { contrato_template: template });
      setCurrentEntidade({ ...currentEntidade, contrato_template: template });
    } catch { /* handled by alert */ }
    finally { setIsSaving(false); }
  };

  const handleCopyVar = (value) => {
    navigator.clipboard.writeText(value);
    setCopiedVar(value);
    setShowCopiedToast(true);
    setTimeout(() => { setShowCopiedToast(false); setTimeout(() => setCopiedVar(null), 300); }, 1800);
  };

  const handleClearSignature = () => sigPadRef.current.clear();

  const handleSaveSignature = async () => {
    if (sigPadRef.current.isEmpty()) {
      setSigMsg({ type: 'warning', text: 'Desenhe sua assinatura antes de salvar.' });
      return;
    }
    setIsSavingSig(true);
    try {
      await axios.post(`/api/funcionarios/${loggedInUser.id}/update-signature`, {
        assinatura: sigPadRef.current.toDataURL('image/png'),
      });
      setSigMsg({ type: 'success', text: 'Assinatura salva com sucesso!' });
    } catch {
      setSigMsg({ type: 'danger', text: 'Erro ao salvar assinatura.' });
    } finally { setIsSavingSig(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        .sig-canvas { width: 100%; height: 180px; cursor: crosshair; display: block; }
        .var-chip:hover { transform: translateY(-1px); box-shadow: 0 3px 10px rgba(0,0,0,.1) !important; }
      `}</style>

      <CopiedToast show={showCopiedToast} />

      {/* HEADER */}
      <div style={{ background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', borderRadius: '14px', padding: '20px 24px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div style={{ width: '44px', height: '44px', borderRadius: '12px', backgroundColor: 'rgba(255,255,255,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <SvgIcon d={ICONS.contract} size={22} color="#fff" stroke={1.8} />
        </div>
        <div>
          <div style={{ fontSize: '16px', fontWeight: '800', color: '#fff' }}>Modelo de Contrato</div>
          <div style={{ fontSize: `calc(12px * var(--font-scale))`, color: 'rgba(255,255,255,.7)' }}>Template e assinatura profissional para geração de contratos</div>
        </div>
      </div>

      {/* GRID PRINCIPAL */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: '16px', marginBottom: '16px' }}>

        {/* EDITOR */}
        <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #f1f5f9' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '7px', background: 'linear-gradient(135deg,#1e3a5f,#2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SvgIcon d={ICONS.contract} size={14} color="#fff" />
            </div>
            <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#1e3a5f' }}>Texto do Contrato</span>
          </div>

          <textarea
            value={template}
            onChange={e => setTemplate(e.target.value)}
            placeholder="Cole aqui o texto legal do contrato. Use as variáveis do painel ao lado para personalização automática..."
            style={{
              ...inputBase, resize: 'vertical', minHeight: '420px',
              lineHeight: '1.7', fontSize: `calc(13px * var(--font-scale))`,
            }}
            {...fh}
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '14px' }}>
            <Btn onClick={handleSave} loading={isSaving} variant="primary">
              <SvgIcon d={ICONS.save} size={13} color="#fff" />
              {isSaving ? 'Salvando...' : 'Salvar Modelo'}
            </Btn>
          </div>
        </div>

        {/* VARIÁVEIS */}
        <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px', paddingBottom: '12px', borderBottom: '2px solid #f1f5f9' }}>
            <div style={{ width: '26px', height: '26px', borderRadius: '7px', background: 'linear-gradient(135deg,#4f46e5,#7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SvgIcon d={ICONS.tag} size={13} color="#fff" />
            </div>
            <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#1e3a5f' }}>Variáveis</span>
          </div>

          <p style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', lineHeight: '1.6', marginBottom: '14px' }}>
            Clique para copiar e cole no texto. Serão substituídas automaticamente pelos dados reais.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {VARIAVEIS.map(v => {
              const isCopied = copiedVar === v.value;
              return (
                <button
                  key={v.value}
                  type="button"
                  className="var-chip"
                  onClick={() => handleCopyVar(v.value)}
                  title={`Copiar ${v.value}`}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '8px 10px', borderRadius: '8px', cursor: 'pointer',
                    border: `1px solid ${isCopied ? '#bbf7d0' : '#e5e7eb'}`,
                    backgroundColor: isCopied ? '#f0fdf4' : '#f8fafc',
                    transition: 'all .2s', textAlign: 'left', fontFamily: 'inherit',
                  }}
                >
                  <div>
                    <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: isCopied ? '#15803d' : '#374151' }}>{v.label}</div>
                    <div style={{ fontSize: `calc(10px * var(--font-scale))`, color: isCopied ? '#16a34a' : '#9ca3af', fontFamily: 'monospace' }}>{v.value}</div>
                  </div>
                  <SvgIcon d={isCopied ? ICONS.check : ICONS.copy} size={13} color={isCopied ? '#16a34a' : '#9ca3af'} stroke={isCopied ? 2.5 : 2} />
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* ASSINATURA */}
      <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #e5e7eb', padding: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', paddingBottom: '14px', borderBottom: '2px solid #f1f5f9' }}>
          <div style={{ width: '28px', height: '28px', borderRadius: '7px', background: 'linear-gradient(135deg,#14532d,#16a34a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <SvgIcon d={ICONS.sign} size={14} color="#fff" />
          </div>
          <span style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#1e3a5f' }}>Minha Assinatura Profissional</span>
        </div>

        <p style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280', marginBottom: '20px', lineHeight: '1.6' }}>
          Desenhe sua assinatura no quadro abaixo. Ela será utilizada automaticamente no rodapé dos contratos que você gerar.
        </p>

        {/* Feedback de assinatura */}
        {sigMsg && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px',
            borderRadius: '9px', marginBottom: '16px',
            backgroundColor: sigMsg.type === 'success' ? '#f0fdf4' : sigMsg.type === 'warning' ? '#fffbeb' : '#fef2f2',
            border: `1px solid ${sigMsg.type === 'success' ? '#bbf7d0' : sigMsg.type === 'warning' ? '#fde68a' : '#fecaca'}`,
          }}>
            <span style={{ fontSize: `calc(12px * var(--font-scale))`, color: sigMsg.type === 'success' ? '#15803d' : sigMsg.type === 'warning' ? '#92400e' : '#dc2626' }}>
              {sigMsg.text}
            </span>
            <button type="button" onClick={() => setSigMsg(null)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: `calc(14px * var(--font-scale))`, color: '#9ca3af' }}>×</button>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', alignItems: 'start' }}>

          {/* Canvas */}
          <div>
            <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '8px' }}>
              Área de assinatura
            </div>
            <div style={{ borderRadius: '12px', border: '2px dashed #cbd5e1', backgroundColor: '#fafafa', overflow: 'hidden', marginBottom: '12px' }}>
              <SignatureCanvas
                ref={sigPadRef}
                penColor="#1e3a5f"
                backgroundColor="rgba(0,0,0,0)"
                canvasProps={{ className: 'sig-canvas' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Btn onClick={handleClearSignature} variant="secondary" small>
                <SvgIcon d={ICONS.eraser} size={12} color="#374151" />
                Limpar
              </Btn>
              <Btn onClick={handleSaveSignature} loading={isSavingSig} variant="success" small>
                <SvgIcon d={ICONS.check} size={12} color="#fff" stroke={2.5} />
                {isSavingSig ? 'Salvando...' : 'Salvar Assinatura'}
              </Btn>
            </div>
          </div>

          {/* Preview de aplicação */}
          <div style={{ backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', textAlign: 'center' }}>
            <div style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '20px' }}>
              Exemplo de aplicação
            </div>
            <div style={{ padding: '30px 20px 10px' }}>
              {/* Linha de assinatura simulada */}
              <div style={{ width: '180px', margin: '0 auto 8px', borderBottom: '1.5px solid #374151' }} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: '4px' }}>
                <SvgIcon d={ICONS.user} size={13} color="#6b7280" />
                <span style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#374151' }}>{loggedInUser?.nome || 'Seu Nome'}</span>
              </div>
              <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>Responsável / Testemunha</div>
            </div>
            <div style={{ marginTop: '16px', padding: '10px', borderRadius: '8px', backgroundColor: '#eff6ff', border: '1px solid #bfdbfe' }}>
              <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#3b82f6', lineHeight: '1.5' }}>
                Sua assinatura desenhada aparecerá acima desta linha nos contratos gerados.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContratoTemplateTab;
